import React, { Suspense, useState, useEffect } from "react";
import "./RenterList.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {  useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  Form,
  Col,
  FormGroup,
  Row,
  Label,
  Input,
} from "reactstrap";
import Loading from "../../components/Loading";
import Button from "@mui/material/Button";
import { FaCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import Footer from "../../DefaultLayout/Footer";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import { BsArrowRight, BsCheck2 ,BsArrowLeft} from "react-icons/bs";
import { addTenantList, getTenantList } from "../../actions/propertyAction";
import { toast } from "react-toastify";
import { connect,useSelector } from "react-redux";
import { 
  CircularProgress,
} from "@mui/material"; 
import { logout,  } from '../../actions/authActions'
import ReactSelect from "react-select";
import makeAnimated from "react-select/animated";
import {
  checkEmptyValidation,
  checkRequiredTextValidationWithMinMax,
  checkRequiredValidationWithMinMax,
  isValidSelection,
  isFutureDate
} from "../../Helpers/Validation";
import moment from "moment";
import CheckboxTree from "react-checkbox-tree";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,
  MdAdd,
  MdRemove,
} from "react-icons/md";
import PerfectScrollbar from "react-perfect-scrollbar";
import { TenantProfileTableLoader } from "../../components/DashboardLoader.js";
import { getContentDetails } from "../../actions/cmsAction";
import Nodes from "../../Helpers/nodesList.js";

const colourStyles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#999999" : null,
      color: "#333333",
    };
  },
};

const icons = {
  check: (
    <MdCheckBox
      className="rct-icon rct-icon-check"
      sx={{ color: "#000!important" }}
    />
  ),
  uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
  halfCheck: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
  ),
  expandClose: <MdChevronRight className="rct-icon rct-icon-expand-close" />,
  expandOpen: <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />,
  expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
  collapseAll: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
  ),
  parentClose: <MdAdd className="rct-icon rct-icon-parent-close" />,
  parentOpen: <MdRemove className="rct-icon rct-icon-parent-open" />,

};


const Renters_list = (props) => {
  const history = useHistory();
   const nodes = Nodes(); 
  const animatedComponents = makeAnimated();
   const currentLanguageCode = localStorage.getItem("prevLangFront") 
  let isSubscribing =localStorage.getItem("isSubscribing")
     const dispatch = useDispatch();
  const { frontLabelsName } = props.label;
 
  const [budget, setBudget] = useState("");
  const [depositType, setDepositType] = useState("");
  const [depositAmount, setDepositAmount] = useState("");
  const [familySize, setFamilySize] = useState("");
  const [child, setChild] = useState("");
  const [workPerson, setWorkPerson] = useState("");
  const [typeOfWork, setTypeOfWork] = useState("");
  const [spouseOfWork, setSpouseOfWork] = useState("");
  const [attachmentType, setAttachmentType] = useState("");
  const [attachments, setAttachments] = useState("");
  const [imagePreview, setPreview] = useState([]);
  const [imagePreviewUrl, setUrl] = useState([]);
  const[disableSubmitButton,setDisableSubmitButton]=useState(false)

  const [checkedTree, setCheckedTree] = useState(["0"]);
  const [expandedTree, setExpandedTree] = useState(["0"]);

  const [clickedTree, setClickedTree] = useState([]);
  const [openZip, setOpenZip] = useState(false);

    const[availableInsurance,setAvailableInsurance]= useState("");
    const [propertyType, setPropertyType] = useState("");
    const [bhk, setBhk] = useState("");
    const [area, setArea] = useState("");
    const[daysDelivery,setDaysDelivery]= useState(null);
    const[years,setYears]= useState("");
    const[pets,setPets]= useState("");
    const[size,setSize]= useState("");
    const[queries,setQueries]= useState("");
    const [availableFrom, setAvailableFrom] = useState(new Date());
    const [availableTo, setAvailableTo] = useState(new Date());
    const [shortTerm, setShortTerm] = useState(false);
    const [longTerm, setLongTerm] = useState(false);
    const[toDateError,setToDateError]= useState("");
    const[fromDateError,setFromDateError]= useState("");
    const[familySizeError,setFamilySizeError]= useState("");
    const[childrenError,setChildrenError]= useState("");
    const[personError,setPersonError]= useState("");
    const[manError,setManError]= useState("");
    const[womanError,setWomanError]= useState("");
    const[insuranceError,setInsuranceError]= useState("");
    const[rentError,setRentError]= useState("");
    const[apartmentError,setApartmentError]= useState("");
    const[areaError,setAreaError]= useState("");
    const[roomError,setRoomError]= useState("");
    const[petError,setPetError]= useState("");
    const[sizeError,setSizeError]= useState("");
    const[QueryError,setQueryError]= useState("");
    const[availabilityError,setAvailabilityError]= useState("");
    const[daysError,setDaysError]= useState("");
    const[yearsError,setYearsError]= useState("");

      const [response, setResponse] = useState(1)
            const [fetchLoading, setFetchLoading] = useState(true);
               const cms = useSelector((state) => state.cmsPages.cms);
                  const data = cms?.data[0]?.content;
  
 
function isValidDateString(dateStr) {
  const date = new Date(dateStr);
  return !isNaN(date.getTime()); // Returns true if valid
}

    useEffect(() => {
           props.getContentDetails(isSubscribing === "true" ?'subscriber-tenant-registry':"non-subscriber-tenant-registry", currentLanguageCode).then((res) => {
            setFetchLoading(false)
              });
        
            
          }, [currentLanguageCode]);
    
    

  useEffect(() => {
    props.getTenantList().then((res) => {
        setResponse(res?.registered ? res?.registered: 1)
      res?.budget && res?.budget !== "undefined"
        ? setBudget(res?.budget)
        : setBudget("");

      

         if(res?.availabilityType == 2){
          setLongTerm(true)
         }else if(res?.availabilityType == 1){
          setShortTerm(true)
         }else{
          setLongTerm(false);
          setShortTerm(false);
         }
          
                  if (res?.availabilityTo !== null) {
                        setAvailableTo(moment(res?.availabilityTo).toDate());
                      }
                      if (res?.availabilityFrom !== null) {
                        setAvailableFrom(moment(res?.availabilityFrom).toDate());
                      }
                setQueries(res?.queries_comment ? res?.queries_comment :"")
                setSize(res?.minimum_size_required ? res?.minimum_size_required :"")
                
                setPets(res?.pets? String(res?.pets):"")
                setArea(res?.area_required ? res?.area_required.toString():"" )
        res?.area_required ? setCheckedTree(res?.area_required) : setCheckedTree(["0"]);
                let b = bhkOptions.filter((e) => res?.rooms?.includes(e.value));
                setBhk(b)
                let a = options.filter((e) => res?.apartmentType?.includes(e.value));
                setPropertyType(a)
                setAvailableInsurance(res?.available_insurance ? res?.available_insurance :"")
  let selectedDeposits = depositOptions.filter((e) => res?.depositType?.includes(e.value));
   selectedDeposits?
         setDepositType(selectedDeposits)
        : setDepositType("");
      res?.depositAmount && res?.depositAmount !== "undefined"
        ? setDepositAmount(res?.depositAmount)
        : setDepositAmount("");
      res?.familySize && res?.familySize !== "undefined"
        ? setFamilySize(res?.familySize)
        : setFamilySize("");
      res?.child && res?.child !== "undefined"
        ? setChild(res?.child)
        : setChild("");
        res?.totalYears && res?.totalYears !== "undefined"
        ? setYears(res?.totalYears)
        : setYears("");

      

        res?.dayDelivery && isValidDateString(res?.dayDelivery)  
        ? setDaysDelivery(moment(res?.dayDelivery).toDate())
        : setDaysDelivery(null);

      res?.workPerson && res?.workPerson !== "undefined"
        ? setWorkPerson(res?.workPerson)
        : setWorkPerson("");
      res?.typeOfWork && res?.typeOfWork !== "undefined"
        ? setTypeOfWork(res?.typeOfWork)
        : setTypeOfWork("");
      res?.spouseOfWork && res?.spouseOfWork !== "undefined"
        ? setSpouseOfWork(res?.spouseOfWork)
        : setSpouseOfWork("");
      res?.attachmentType && res?.attachmentType !== "undefined"
        ? setAttachmentType(res?.attachmentType)
        : setAttachmentType("");
      setAttachments(res?.attachments);

      setPreview(res?.attachments);
      setUrl(res?.attachments);    

    
    });
  }, []);



    const depositOptions=[
    {
label: frontLabelsName
  ? frontLabelsName.filter(
      (e) => e.key == "lbl_renters_insurance"
    ).length > 0
    ? frontLabelsName.filter(
        (e) => e.key == "lbl_renters_insurance"
      )[0]["value"] || "lbl_renters_insurance"
    : "lbl_renters_insurance"
  : "lbl_renters_insurance",
  value:"renters_insurance"
  },
  {
    label:frontLabelsName
    ? frontLabelsName.filter(
        (e) => e.key == "lbl_security_deposit"
      ).length > 0
      ? frontLabelsName.filter(
          (e) => e.key == "lbl_security_deposit"
        )[0]["value"] || "lbl_security_deposit"
      : "lbl_security_deposit"
    : "lbl_security_deposit",
    value:"security_deposit"
  },
  {
label:frontLabelsName
? frontLabelsName.filter(
    (e) => e.key == "lbl_bank_guarantee"
  ).length > 0
  ? frontLabelsName.filter(
      (e) => e.key == "lbl_bank_guarantee"
    )[0]["value"] || "lbl_bank_guarantee"
  : "lbl_bank_guarantee"
: "lbl_bank_guarantee",
value:"bank_guarantee"
  },
  {
    label:frontLabelsName
    ? frontLabelsName.filter(
        (e) => e.key == "lbl_collateral"
      ).length > 0
      ? frontLabelsName.filter(
          (e) => e.key == "lbl_collateral"
        )[0]["value"] || "lbl_collateral"
      : "lbl_collateral"
    : "lbl_collateral",
    value:"collateral"
  },
  {
    label:frontLabelsName
    ? frontLabelsName.filter(
        (e) => e.key == "lbl_other"
      ).length > 0
      ? frontLabelsName.filter(
          (e) => e.key == "lbl_other"
        )[0]["value"] || "lbl_other"
      : "lbl_other"
    : "lbl_other",
      value:"other"
  },



]

 const handleDepositChange=(selectedOption)=>{
    setDepositType(selectedOption)
  }

  const handleZipCode = () => {
    setOpenZip(!openZip);
  
  };

  const handleSkip = () => {
 

    dispatch({
      type: "SET_STEP",
      payload: { step: 3, status: true },
    });
    localStorage.setItem("currentStepIndex", 3);
    history.push("/register-rental-profile");
  };

  const handleBackTenantList=()=>{
    dispatch({
      type: "SET_STEP",
      payload: { step: 1, status: true },
    });
    localStorage.setItem("currentStepIndex", 1);
    history.push("/register-basic-info"); 
  }


  function priceFormat(x) {
    const data = x?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }
  let PriceArray = [];
  for (let i = 1; i <= 1500; i++) {
    PriceArray.push(priceFormat(1000 * [i]));
  }

  let daysArray=[]
  for (let i = 1; i <= 365; i++) {
    daysArray.push(i);
  }




  const handleAddTenantList = () => {
    let from_err = "";
    let to_err = "";
    let err_family_size = "";
    let err_children = "";
    let err_person= "";
    let err_man = "";
    let err_woman = "";
    let err_insurance = "";
    let err_rent = "";
    let err_apartmant = "";
    let err_area = "";
    let err_room="";
    let err_pet="";
    let err_size="";
    let err_years="";

    let err_day_delivery=""
    let availability_type="";
 

    // if(longTerm===true || shortTerm === true ){
    //   from_err = isFutureDate(
    //     availableFrom,
    //     "lbl_available_from"
    //   );
    // }
        
    //         if (shortTerm) {
    //           to_err = isFutureDate(availableTo, "lbl_available_to");
    //         }
    
    //         if(shortTerm && availableTo&& availableFrom){
    //           let check= isValidDateRange(availableFrom,availableTo)
           
    //           if(!check){
    //             to_err = "lbl_available_to_date_should_not_be_before_available_date";
    //           }else{
    //             to_err =""
    //           }
    //         }

    if(isSubscribing !== "true"){
      // if(shortTerm ==false && longTerm ==false ){
      //   availability_type ="lbl_length_of_rental_is_required"
      // }

 
    err_family_size = checkEmptyValidation(familySize,"lbl_family_size");
    err_children = checkEmptyValidation(child,"lbl_no_of_children");
    err_person = checkEmptyValidation(workPerson,"lbl_no_of_person");
    err_man = checkRequiredTextValidationWithMinMax(typeOfWork.trim(),"lbl_man_type_of_work", 2, 50);
    err_woman = checkRequiredTextValidationWithMinMax(spouseOfWork,"lbl_women_type_of_work",2,50);
    err_insurance = isValidSelection(depositType,"lbl_insurance");
    err_rent = checkRequiredValidationWithMinMax(budget,"lbl_rent_budget",3,7);
    err_apartmant = checkEmptyValidation(propertyType,"lbl_apartment_type");
  
    err_room = checkEmptyValidation(bhk,"lbl_rooms");
    err_pet = checkEmptyValidation(pets,"lbl_pets");
    err_years = checkEmptyValidation(years,"lbl_length_of_rental");
    err_day_delivery = isFutureDate(daysDelivery,"lbl_day_delivery");
    err_size = checkRequiredValidationWithMinMax(size,"lbl_size",1,6);
    if (checkedTree[0]=="0"|| checkedTree.length==0 ) {
      err_area = "lbl_area_is_required";
    }
  
          }
    if(err_years||err_day_delivery||  availability_type|| from_err||to_err|| err_family_size||err_children||err_person||err_man||err_woman||err_insurance||
      err_rent||err_apartmant||err_area||err_room||err_pet||err_size
    ){
      setDaysError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_day_delivery).length > 0
          ? frontLabelsName.filter((e) => e.key == err_day_delivery)[0][
              "value"
            ] || err_day_delivery
          : err_day_delivery
        : err_day_delivery)
        setYearsError(frontLabelsName
          ? frontLabelsName.filter((e) => e.key == err_years).length > 0
            ? frontLabelsName.filter((e) => e.key == err_years)[0][
                "value"
              ] || err_years
            : err_years
          : err_years)
        
      setAvailabilityError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == availability_type).length > 0
          ? frontLabelsName.filter((e) => e.key == availability_type)[0][
              "value"
            ] || availability_type
          : availability_type
        : availability_type)
      setFromDateError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == from_err).length > 0
          ? frontLabelsName.filter((e) => e.key == from_err)[0][
              "value"
            ] || from_err
          : from_err
        : from_err)
      setToDateError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == to_err).length > 0
          ? frontLabelsName.filter((e) => e.key == to_err)[0]["value"] ||
          to_err
          : to_err
        : to_err)
      setFamilySizeError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_family_size).length > 0
          ? frontLabelsName.filter((e) => e.key == err_family_size)[0]["value"] ||
          err_family_size
          : err_family_size
        : err_family_size)
      setChildrenError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_children).length > 0
          ? frontLabelsName.filter((e) => e.key == err_children)[0]["value"] ||
          err_children
          : err_children
        : err_children)
      setPersonError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_person).length > 0
          ? frontLabelsName.filter((e) => e.key == err_person)[0]["value"] ||
          err_person
          : err_person
        : err_person)
      setManError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_man).length > 0
          ? frontLabelsName.filter((e) => e.key == err_man)[0]["value"] ||
          err_man
          : err_man
        : err_man)
      setWomanError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_woman).length > 0
          ? frontLabelsName.filter((e) => e.key == err_woman)[0]["value"] ||
          err_woman
          : err_woman
        : err_woman)
      setInsuranceError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_insurance).length > 0
          ? frontLabelsName.filter((e) => e.key == err_insurance)[0]["value"] ||
          err_insurance
          : err_insurance
        : err_insurance)
      setRentError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_rent).length > 0
          ? frontLabelsName.filter((e) => e.key == err_rent)[0]["value"] ||
          err_rent
          : err_rent
        : err_rent)
      setApartmentError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_apartmant).length > 0
          ? frontLabelsName.filter((e) => e.key == err_apartmant)[0]["value"] ||
          err_apartmant
          : err_apartmant
        : err_apartmant)
      setAreaError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_area).length > 0
          ? frontLabelsName.filter((e) => e.key == err_area)[0]["value"] ||
          err_area
          : err_area
        : err_area)
      setRoomError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_room).length > 0
          ? frontLabelsName.filter((e) => e.key == err_room)[0]["value"] ||
          err_room
          : err_room
        : err_room)
      setPetError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_pet).length > 0
          ? frontLabelsName.filter((e) => e.key == err_pet)[0]["value"] ||
          err_pet
          : err_pet
        : err_pet)
      setSizeError(frontLabelsName
        ? frontLabelsName.filter((e) => e.key == err_size).length > 0
          ? frontLabelsName.filter((e) => e.key == err_size)[0]["value"] ||
          err_size
          : err_size
        : err_size)
    

    }else{
      setAvailabilityError("")
      setFromDateError("")
      setToDateError("")
      setFamilySizeError("")
      setChildrenError("")
      setPersonError("")
      setManError("")
      setWomanError("")
      setInsuranceError("")
      setRentError("")
      setApartmentError("")
      setAreaError("")
      setRoomError("")
      setPetError("")
      setSizeError("")
      setQueryError("")
      setDaysError("")
      setYearsError("")
 

      setDisableSubmitButton(true)
      let temptypeArray = [];

      propertyType?.map((a) => temptypeArray.push(a.value));

          let tempDepositType =[]
    depositType.map((a) => tempDepositType.push(a.value))
  
      let temptBhkArray = [];
      bhk.map((a) => temptBhkArray.push(a.value));
      const formData = new FormData();
       formData.append("registered",Number(response) );
      formData.append("budget", budget);
    if( tempDepositType.length>0){
      for (let i = 0; i < tempDepositType.length; i++) {
        formData.append("depositType", tempDepositType[i]);
      }}else{
        formData.append("depositType", "");
      }
      formData.append("depositAmount", depositAmount);
      formData.append("familySize", familySize);
      formData.append("dayDelivery", daysDelivery);
      formData.append("totalYears", years);
    
      formData.append("available_insurance", Number(availableInsurance) );
    formData.append("pets", pets);
    formData.append("queries_comment", queries);

    formData.append("minimum_size_required", Number(size));
    if( checkedTree.length>0){
      for (let i = 0; i < checkedTree.length; i++) {
        formData.append("area_required", checkedTree[i]);
      }}else{
        formData.append("area_required", "");
      }
    if( temptypeArray.length>0){
      for (let i = 0; i < temptypeArray.length; i++) {
      formData.append("apartmentType", temptypeArray[i]);
      }}else{
        formData.append("apartmentType", "");
      }
      if(temptBhkArray.length>0){
      for (let i = 0; i < temptBhkArray.length; i++) {
      formData.append("rooms", temptBhkArray[i]);
      }}else{
        formData.append("rooms", ""); 
      }
    formData.append("availabilityType",  longTerm === true ? 2: shortTerm === true ? 1 : "");
    formData.append("availabilityTo", longTerm === true ? "" : availableTo);
    formData.append("availabilityFrom", availableFrom);
  
      formData.append("child", child);
      formData.append("workPerson", workPerson);
      formData.append("typeOfWork", typeOfWork);
      formData.append("spouseOfWork", spouseOfWork);
  
  
      formData.append("attachmentType", attachmentType);
      for (let i = 0; i < imagePreviewUrl?.length; i++) {
        formData.append("attachments", imagePreviewUrl[i]);
      }

  
  
      props
        .addTenantList(formData)
        .then((res) => {
          setDisableSubmitButton(false)
          toast.success(
            frontLabelsName
              ? frontLabelsName.filter((e) => e.key == res.data.message).length > 0
                ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
                    "value"
                  ] || res.data.message
                : res.data.message
              : res.data.message
          );
        
            dispatch({
              type: "SET_STEP",
              payload: { step: 3, status: true },
            });
            localStorage.setItem("currentStepIndex", 3);
            history.push("/register-rental-profile");


           
         
        
        })
        .catch((err) => {
       if(err.response.status==401){
        history.push( "/login")
        dispatch({
          type:"SET_STEP",
          payload:{step:0,status:false}
       });
       localStorage.removeItem("isSubscribing")
     
       props.logout()
       }
          setDisableSubmitButton(false)
          toast.error(
            frontLabelsName
              ? frontLabelsName.filter((e) => e.key == err.response.data.message)
                  .length > 0
                ? frontLabelsName.filter((e) => e.key == err.response.data.message)[0][
                    "value"
                  ] || err.response.data.message
                : err.response.data.message
              : err.response.data.message
          );
        });
    }

  };

 

  let YearsArray = [];
  for (let i = 2; i <= 25; i++) {
       YearsArray.push(`${i} ${frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_years").length >
          0
          ? frontLabelsName.filter((e) => e.key == "lbl_years")[0][
              "value"
            ] || "lbl_years"
          : "lbl_years"
        : "lbl_years"}` );
  }

    let monthsArray = [];
  for (let i = 1; i <= 12; i++) {
       monthsArray.push(`${i} ${frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_months").length >
          0
          ? frontLabelsName.filter((e) => e.key == "lbl_months")[0][
              "value"
            ] || "lbl_months"
          : "lbl_months"
        : "lbl_months"}`  );
  }
  const handleChange = (selectedOption) => {
    setPropertyType(selectedOption);
  };

  const options = [
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_detached_house").length >
          0
          ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")[0][
              "value"
            ] || "lbl_detached_house"
          : "lbl_detached_house"
        : "lbl_detached_house",
      value: "detachedHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_duplex").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0]["value"] ||
            "lbl_duplex"
          : "lbl_duplex"
        : "lbl_duplex",
      value: "duplex",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")
            .length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")[0][
              "value"
            ] || "lbl_triple_apt_house"
          : "lbl_triple_apt_house"
        : "lbl_triple_apt_house",
      value: "tripleAptHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_apt_building").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")[0][
              "value"
            ] || "lbl_apt_building"
          : "lbl_apt_building"
        : "lbl_apt_building",
      value: "aptBulding",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin").length >
          0
          ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")[0][
              "value"
            ] || "lbl_townhouse_twin"
          : "lbl_townhouse_twin"
        : "lbl_townhouse_twin",
      value: "townhouseTwin",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
            "lbl_garage"
          : "lbl_garage"
        : "lbl_garage",
      value: "garage",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_summer_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")[0][
              "value"
            ] || "lbl_summer_house"
          : "lbl_summer_house"
        : "lbl_summer_house",
      value: "summerHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")[0][
              "value"
            ] || "lbl_co_tenant"
          : "lbl_co_tenant"
        : "lbl_co_tenant",
      value: "cotenant",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")
            .length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")[0][
              "value"
            ] || "lbl_hotel_guest_house"
          : "lbl_hotel_guest_house"
        : "lbl_hotel_guest_house",
      value: "hotelGesthouse",
    },
  ];

  const bhkOptions = [
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_storage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_storage")[0]["value"] ||
            "lbl_storage"
          : "lbl_storage"
        : "lbl_storage",
      value: "Storage",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_single_room").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_single_room")[0][
              "value"
            ] || "lbl_single_room"
          : "lbl_single_room"
        : "lbl_single_room",
      value: "Single Room",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_studio").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_studio")[0]["value"] ||
            "lbl_studio"
          : "lbl_studio"
        : "lbl_studio",
      value: "Studio",
    },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9+", value: "9+" },
  ];

  const handleBhkChange = (selectedOption) => {
    setBhk(selectedOption);
  };
  var zipcustom;
  if (checkedTree && checkedTree[0] == "0") {
    zipcustom = "";
  } else if (checkedTree && checkedTree[0] != "0") {
    zipcustom = checkedTree?.toString();
  }


  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />

        <DashboardNavbar/>
      </Suspense>
      <div className="container">
        <div className="main-renter-list list-Renterl renter-list12">
          <div className="trams-condition-box">
            <div className="row">
              <div className="col-lg-9 col-md-12 custom-flex-made-basic-info ">
                <Form className="st-fl-hg-trem-basic">
                  <div className="set-pdd-basic-info ps-0">
                    <div className="text-center">
                      <h2 className="custom-h2-size1 mb-2">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_tenant_list")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_tenant_list"
                              )[0]["value"] || "lbl_tenant_list"
                            : "lbl_tenant_list"
                          : "lbl_tenant_list"}
                      </h2>
                         
                                               <div className="row background-color-class text-start mt-2">
                                                              
                                                                     {!fetchLoading &&  data && (
                                                                                              <div dangerouslySetInnerHTML={{ __html: data }} className="dangeroussly-div"/>
                                                                                            )}
                                                                                 <div className="width-100-percent">
                                                                                 {fetchLoading && <TenantProfileTableLoader width={"100%"}/>} 
                                                                                 </div>
                                                                              
                                                                </div>
                                                                <div className="row">
                                            <div className="col-12 ">
                                            <div className="field-group21 d-flex align-items-center gap-1 gap-sm-3">
                                             
                                                <label className="gap-1 d-flex align-items-center custom-radio">
                          <input type="radio" name="response" value={1} className="new-radio"    checked={response ==1}
                              onChange={(e) => setResponse(e.target.value)}/>
                          <span class="checkmark"></span>   {frontLabelsName
                                                    ? frontLabelsName.filter(
                                                        (e) => e.key == "lbl_yes"
                                                      ).length > 0
                                                      ? frontLabelsName.filter(
                                                          (e) => e.key == "lbl_yes"
                                                        )[0]["value"] || "lbl_yes"
                                                      : "lbl_yes"
                                                    : "lbl_yes"}
                        </label>
                      
                        <label className="gap-1 d-flex align-items-center custom-radio">
                          <input type="radio" name="response" value={2}  className="new-radio"    checked={response ==2}
                              onChange={(e) => setResponse(e.target.value)}/>
                          <span class="checkmark"></span>   {frontLabelsName
                                                    ? frontLabelsName.filter(
                                                        (e) => e.key == "lbl_no"
                                                      ).length > 0
                                                      ? frontLabelsName.filter(
                                                          (e) => e.key == "lbl_no"
                                                        )[0]["value"] || "lbl_no"
                                                      : "lbl_no"
                                                    : "lbl_no"}
                        </label>
                      
                        <label className="gap-1 d-flex align-items-center custom-radio">
                          <input type="radio" name="response" value={3}  className="new-radio"    checked={response ==3}
                              onChange={(e) => setResponse(e.target.value)} />
                          <span class="checkmark"></span>   {frontLabelsName
                                                    ? frontLabelsName.filter(
                                                        (e) => e.key == "lbl_unregister"
                                                      ).length > 0
                                                      ? frontLabelsName.filter(
                                                          (e) => e.key == "lbl_unregister"
                                                        )[0]["value"] || "lbl_unregister"
                                                      : "lbl_unregister"
                                                    : "lbl_unregister"}
                        </label>
                                             
                                              </div>
                                           
                                            </div>
                                          </div>
                                          <hr/>
                    </div>
                 
                 <div className="row d-flex pt-2">
                                    <div className="col-12 col-lg-6">
                                                 <div className="d-flex ">
                                    <strong className="set-black set-yellow mb-2">
                                            {frontLabelsName
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_family_information"
                                                ).length > 0
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_family_information"
                                                  )[0]["value"] || "lbl_family_information"
                                                : "lbl_family_information"
                                              : "lbl_family_information"}
                                          </strong>
                                          </div>
                                          <FormGroup className="pt-1 set">
                                            <Row className="renter-row-style">
                                            <Col lg="12" className="renter-input-width1 d-flex align-items-center ">
                                            <Label className="renter-info-label  width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_size_of_family"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_size_of_family"
                                                    )[0]["value"] || "lbl_size_of_family"
                                                  : "lbl_size_of_family"
                                                : "lbl_size_of_family"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100">
                                            <select
                                                  className={`select_style set-bg-feild ${!familySize ? "has-placeholder" : ""}`}
                                              id="inputGroupSelect02"
                                              value={familySize}
                                              onChange={(e) => setFamilySize(e.target.value)}
                                            >
                                              <option value="" disabled>
                                                {frontLabelsName
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_size_of_family"
                                                    ).length > 0
                                                    ? frontLabelsName.filter(
                                                        (e) => e.key == "lbl_size_of_family"
                                                      )[0]["value"] || "lbl_size_of_family"
                                                    : "lbl_size_of_family"
                                                  : "lbl_size_of_family"}
                                              </option>
                                              <option value="1">1</option>
                                              <option value="2">2</option>
                                              <option value="3">3</option>
                                              <option value="4">4</option>
                                              <option value="5">5</option>
                                              <option value="6">6+</option>
                                            </select>
                                        
                                            {familySizeError && (
                                  <span className="invalid_span">
                                    {familySizeError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                          <Col lg="12" className="renter-input-width2 d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_no_children"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_no_children"
                                                    )[0]["value"] || "lbl_no_children"
                                                  : "lbl_no_children"
                                                : "lbl_no_children"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100">
                                            <select
                                                 className={`select_style set-bg-feild ${!child ? "has-placeholder" : ""}`}
                                              id="inputGroupSelect02"
                                              value={child}
                                              onChange={(e) => setChild(e.target.value)}
                                            >
                                              <option value="" disabled>
                                                {frontLabelsName
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_no_children"
                                                    ).length > 0
                                                    ? frontLabelsName.filter(
                                                        (e) => e.key == "lbl_no_children"
                                                      )[0]["value"] || "lbl_no_children"
                                                    : "lbl_no_children"
                                                  : "lbl_no_children"}
                                              </option>
                                              <option value="1">1</option>
                                              <option value="2">2</option>
                                              <option value="3">3</option>
                                              <option value="4">4</option>
                                              <option value="5">5</option>
                                              <option value="6">6+</option>
                                            </select>
                                            {childrenError && (
                                  <span className="invalid_span">
                                    {childrenError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                          <Col lg="12" className="renter-input-width3 d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_no_of_person_work"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_no_of_person_work"
                                                    )[0]["value"] || "lbl_no_of_person_work"
                                                  : "lbl_no_of_person_work"
                                                : "lbl_no_of_person_work"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100">
                                            <select
                                               className={`select_style set-bg-feild ${!workPerson ? "has-placeholder" : ""}`}
                                              id="inputGroupSelect02"
                                              value={workPerson}
                                              onChange={(e) => setWorkPerson(e.target.value)}
                                            >
                                              <option value="" disabled>
                                                {frontLabelsName
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_no_of_person_work"
                                                    ).length > 0
                                                    ? frontLabelsName.filter(
                                                        (e) =>
                                                          e.key == "lbl_no_of_person_work"
                                                      )[0]["value"] || "lbl_no_of_person_work"
                                                    : "lbl_no_of_person_work"
                                                  : "lbl_no_of_person_work"}
                                              </option>
                                              <option value="1">1</option>
                                              <option value="2">2</option>
                                              <option value="3">3</option>
                                              <option value="4">4</option>
                                              <option value="5">5</option>
                                              <option value="6">6+</option>
                                            </select>
                                            {personError && (
                                  <span className="invalid_span">
                                    {personError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                          <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_rent_budget"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_rent_budget"
                                                    )[0]["value"] || "lbl_rent_budget"
                                                  : "lbl_rent_budget"
                                                : "lbl_rent_budget"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100">
                                           
                                            <select
                                               className={`select_style set-bg-feild ${!budget ? "has-placeholder" : ""}`}
                                              id="inputGroupSelect02"
                                              value={budget}
                                              onChange={(e) => setBudget(e.target.value)}
                                            >
                                              <option value="" disabled>
                                                {  frontLabelsName
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_rent_budget"
                                                    ).length > 0
                                                    ? frontLabelsName.filter(
                                                        (e) => e.key == "lbl_rent_budget"
                                                      )[0]["value"] || "lbl_rent_budget"
                                                    : "lbl_rent_budget"
                                                  : "lbl_rent_budget"}
                                              </option>
                                              {PriceArray &&
                                PriceArray.length > 0 &&
                                PriceArray.map((data, i) => (
                                  <option value={data} key={i}>
                                    {data}
                                  </option>
                                ))}
                                            </select>
                              
                                          
                                                           {rentError && (
                                  <span className="invalid_span">
                                    {rentError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                      
                                          <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_available_insurances"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_available_insurances"
                                                    )[0]["value"] || "lbl_available_insurances"
                                                  : "lbl_available_insurances"
                                                : "lbl_available_insurances"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100">
                                                        <ReactSelect
                                                                   defaultValue={depositType}
                                                                   styles={colourStyles}
                                                                   components={animatedComponents}
                                                                   placeholder=   {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_available_insurances"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_available_insurances"
                                      )[0]["value"] || "lbl_available_insurances"
                                    : "lbl_available_insurances"
                                  : "lbl_available_insurances"}
                                                                   name="depositType"
                                                                   options={depositOptions}
                                                                   onChange={handleDepositChange}
                                                                   value={depositType}
                                                                   isClearable
                                                                   isMulti
                                                                
                                                                 />
                                            {insuranceError && (
                                  <span className="invalid_span">
                                    {insuranceError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                              <Col lg="12" className="d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_man_type_work"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_man_type_work"
                                                    )[0]["value"] || "lbl_man_type_work"
                                                  : "lbl_man_type_work"
                                                : "lbl_man_type_work"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100">
                                            <Input
                                              type="text"
                                              name="Man type of work"
                                              placeholder={
                                                frontLabelsName
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_man_type_work"
                                                    ).length > 0
                                                    ? frontLabelsName.filter(
                                                        (e) => e.key == "lbl_man_type_work"
                                                      )[0]["value"] || "lbl_man_type_work"
                                                    : "lbl_man_type_work"
                                                  : "lbl_man_type_work"
                                              }
                                              className="input_style"
                                              value={typeOfWork}
                                              onChange={(e) => setTypeOfWork(e.target.value)}
                                            />
                                                             {manError && (
                                  <span className="invalid_span">
                                    {manError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                          <Col lg="12" className="d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_women_type_work"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_women_type_work"
                                                    )[0]["value"] || "lbl_women_type_work"
                                                  : "lbl_women_type_work"
                                                : "lbl_women_type_work"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100">
                                            <Input
                                              type="text"
                                              placeholder={
                                                frontLabelsName
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_women_type_work"
                                                    ).length > 0
                                                    ? frontLabelsName.filter(
                                                        (e) => e.key == "lbl_women_type_work"
                                                      )[0]["value"] || "lbl_women_type_work"
                                                    : "lbl_women_type_work"
                                                  : "lbl_women_type_work"
                                              }
                                              className="input_style"
                                              value={spouseOfWork}
                                              onChange={(e) =>
                                                setSpouseOfWork(e.target.value)
                                              }
                                            />
                                                                               {womanError && (
                                  <span className="invalid_span">
                                    {womanError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                            </Row>
                                          </FormGroup>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                      <div className="d-flex justify-content-end">
                                    <strong className="set-black set-yellow mb-2">
                                        {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_housing_need"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_housing_need"
                          )[0]["value"] || "lbl_housing_need"
                        : "lbl_housing_need"
                      : "lbl_housing_need"}
                                      </strong>
                                      </div>
                                      <FormGroup className="pt-1 set">
                                        <Row className="renter-row-style">
                                     
                            
                                         <Col lg="12" className="renter-input-width1 width-100class d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_apartment_type"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_apartment_type"
                                                    )[0]["value"] || "lbl_apartment_type"
                                                  : "lbl_apartment_type"
                                                : "lbl_apartment_type"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100">
                                            <ReactSelect                         
                                        styles={colourStyles}
                                        components={animatedComponents}
                                        placeholder=   {frontLabelsName
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_apartment_type"
                                            ).length > 0
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_apartment_type"
                                              )[0]["value"] || "lbl_apartment_type"
                                            : "lbl_apartment_type"
                                          : "lbl_apartment_type"}
                                        name="property type"
                                        options={options}
                                        onChange={handleChange}
                                        value={propertyType}
                                        isClearable
                                        isMulti
                                      />
                                                                     {apartmentError && (
                                  <span className="invalid_span">
                                    {apartmentError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                          <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_area"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_area"
                                                    )[0]["value"] || "lbl_area"
                                                  : "lbl_area"
                                                : "lbl_area"} {isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100">
                                            <Input
                                              type="text"
                                              placeholder={
                                               frontLabelsName
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_area"
                                                    ).length > 0
                                                    ? frontLabelsName.filter(
                                                        (e) => e.key == "lbl_area"
                                                      )[0]["value"] || "lbl_area"
                                                    : "lbl_area"
                                                  : "lbl_area"
                                              }
                                              className="input_style"
                                              value={zipcustom}
                                              onClick={handleZipCode}
                                           
                                            />
                                               {openZip && (
                          <div className="tenat-profile-zipcode-style">
                            <PerfectScrollbar
                              style={{
                                maxHeight: "300px",
                                overflowX: "hidden",

                                width: "100%",
                              }}
                            >
                              <CheckboxTree
                                nodes={nodes}
                                checked={checkedTree}
                                expanded={expandedTree}
                                expandOnClick={true}
                                onClick={(clickedTree) =>
                                  setClickedTree(clickedTree)
                                }
                                onCheck={(checkedTree) => {
                                  setCheckedTree(checkedTree);
                                }}
                                onExpand={(expandedTree) =>
                                  setExpandedTree(expandedTree)
                                }
                                icons={icons}
                     
                              />
                            </PerfectScrollbar>
                          </div>
                        )}
                                                                                       {areaError && (
                                  <span className="invalid_span">
                                    {areaError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                          <Col lg="12" className="renter-input-width1 width-100class d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_rooms"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_rooms"
                                                    )[0]["value"] || "lbl_rooms"
                                                  : "lbl_rooms"
                                                : "lbl_rooms"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100">
                                            <ReactSelect
                                        defaultValue={bhk}
                                        styles={colourStyles}
                                        components={animatedComponents}
                                        placeholder={
                                          frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_select_bhk"
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_select_bhk"
                                                )[0]["value"] || "lbl_select_bhk"
                                              : "lbl_select_bhk"
                                            : "lbl_select_bhk"
                                        }
                                        name="bhk"
                                        options={bhkOptions}
                                        onChange={handleBhkChange}
                                        value={bhk}
                                        isClearable
                                        isMulti
                                   
                                      />
                                                                                              {roomError && (
                                  <span className="invalid_span">
                                    {roomError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                          <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_pets"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_pets"
                                                    )[0]["value"] || "lbl_pets"
                                                  : "lbl_pets"
                                                : "lbl_pets"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100 ">
                                              <div className="d-flex align-items-center  flex-wrap ">
                                            <label className="gap-1 d-flex align-items-center custom-radio  ">
    <input type="radio" name="pets" value={"1"} className="new-radio"     checked={pets === "1"}
        onChange={(e) => setPets("1")} />
    <span class="checkmark"></span>   {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_yes"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_yes"
                                  )[0]["value"] || "lbl_yes"
                                : "lbl_yes"
                              : "lbl_yes"}
  </label>

  <label className="gap-1 d-flex align-items-center custom-radio ">
    <input type="radio" name="pets" value={"2"}  className="new-radio"    checked={pets ==="2"}
        onChange={(e) => setPets("2")}/>
    <span class="checkmark"></span>   {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_no"
                                  )[0]["value"] || "lbl_no"
                                : "lbl_no"
                              : "lbl_no"}
  </label>
  <label className="gap-1 d-flex align-items-center custom-radio me-0">
    <input type="radio" name="pets" value={"3"}  className="new-radio"    checked={pets ==="3"}
        onChange={(e) => setPets("3")}/>
    <span class="checkmark"></span>   {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_agreement"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_agreement"
                                  )[0]["value"] || "lbl_agreement"
                                : "lbl_agreement"
                              : "lbl_agreement"}
  </label>
  </div>
                                           
                                            
                                            {petError && (
                                  <span className="invalid_span">
                                    {petError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                        
                                          <Col lg="12" className="d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_days_delivery"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_days_delivery"
                                                    )[0]["value"] || "lbl_days_delivery"
                                                  : "lbl_days_delivery"
                                                : "lbl_days_delivery"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                    
                                               <div style={{ position: "relative" }} className="width-100">
                                          <FaCalendarAlt
                                           className="date-stylexx"
                                          />
              
                                          <DatePicker
                                            selected={daysDelivery}
                                            onChange={(date) => setDaysDelivery(date)}
                                            dateFormat="dd/MM/yyyy"
                                            isClearable={daysDelivery ? true : false}
                                            placeholderText= {frontLabelsName
                                                                            ? frontLabelsName.filter(
                                                                                (e) => e.key == "lbl_days_delivery"
                                                                              ).length > 0
                                                                              ? frontLabelsName.filter(
                                                                                  (e) => e.key == "lbl_days_delivery"
                                                                                )[0]["value"] || "lbl_days_delivery"
                                                                              : "lbl_days_delivery"
                                                                            : "lbl_days_delivery"}
                                            className="date_style"
                                            minDate={new Date()}
                                          />
                                                                                       {daysError && (
                                  <span className="invalid_span">
                                    {daysError}
                                  </span>
                                )}
                                        </div>


                              
                          
                                          </Col>
                                          <Col lg="12" className="d-flex align-items-center">
                                            <Label className="renter-info-label width-class  lineheight-class fw-semibold">
                                            {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_length_rental"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_length_rental"
                                        )[0]["value"] || "lbl_length_rental"
                                      : "lbl_length_rental"
                                    : "lbl_length_rental"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100 ">
                                          
                                                        
                                                                                                      <select
                                               className={`select_style set-bg-feild ${!years ? "has-placeholder" : ""}`}
                                              id="inputGroupSelect02"
                                              value={years}
                                              onChange={(e) => setYears(e.target.value)}
                                            >
                                              <option value="" disabled>
                                                {frontLabelsName?.find(e => e.key === "lbl_length_rental")?.value || "lbl_length_rental"}
                                         
                                              </option>
                                              {monthsArray?.length>0 && monthsArray.map((data, i) => (
                                  <option value={data} key={i}>
                                    {data}
                                  </option>
                                ))}
                                              {YearsArray &&
                                YearsArray.length > 0 &&
                                YearsArray.map((data, i) => (
                                  <option value={data } key={i}>
                                    {data} 
                                  </option>
                                ))}
                                            </select>
                                            
                                                                               {yearsError && (
                                  <span className="invalid_span">
                                    {yearsError}
                                  </span>
                                )}
                              
                                </div>
                                          </Col>
                                            <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_minimum_size"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_minimum_size"
                                                    )[0]["value"] || "lbl_minimum_size"
                                                  : "lbl_minimum_size"
                                                : "lbl_minimum_size"} (m<sup>2</sup>){isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                            <div className="width-100">
                                            <Input
                                              type="number"
                                              placeholder=  {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_minimum_size"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_minimum_size"
                                                    )[0]["value"] || "lbl_minimum_size"
                                                  : "lbl_minimum_size"
                                                : "lbl_minimum_size"}
                                              className="input_style"
                                              value={size}
                                              onChange={(e) =>
                                                setSize(e.target.value)
                                              }
                                            />
                                                       {sizeError && (
                                  <span className="invalid_span">
                                    {sizeError}
                                  </span>
                                )}
                                </div>
                                       
                                          </Col>
                                          <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                              {frontLabelsName
                                                ? frontLabelsName.filter(
                                                    (e) => e.key == "lbl_queries"
                                                  ).length > 0
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_queries"
                                                    )[0]["value"] || "lbl_queries"
                                                  : "lbl_queries"
                                                : "lbl_queries"}
                                            </Label>
                                            <div className="width-100">
                                            <Input
                                              type="textarea"
                                              row="5"
                                              placeholder={
                                               frontLabelsName
                                                  ? frontLabelsName.filter(
                                                      (e) => e.key == "lbl_queries"
                                                    ).length > 0
                                                    ? frontLabelsName.filter(
                                                        (e) => e.key == "lbl_queries"
                                                      )[0]["value"] || "lbl_queries"
                                                    : "lbl_queries"
                                                  : "lbl_queries"
                                              }
                                              className="input_style textareaxx"
                                              value={queries}
                                              onChange={(e) =>
                                                setQueries(e.target.value)
                                              }
                                            />
                                                                          {QueryError && (
                                  <span className="invalid_span">
                                    {QueryError}
                                  </span>
                                )}
                                </div>
                                          </Col>
                                          {/* <Col lg="12" className="renter-input-width1  ">
                                     
                                            <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                            {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_length_rental"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_length_rental"
                                        )[0]["value"] || "lbl_length_rental"
                                      : "lbl_length_rental"
                                    : "lbl_length_rental"}{isSubscribing !== "true" &&<span className="invalid_span">*</span>}
                                            </Label>
                                 
                                  <Row className="row_style1">
                                    <Col
                                      lg="6"
                                      md="6"
                                      sm="6"
                                      xs="6"
                                      className="checkbox-styles1"
                                    >
                                      <div className="field-group21  d-flex align-items-center">
                                        <label htmlFor="16" className="fw-semibold">
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_short_term"
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_short_term"
                                                )[0]["value"] || "lbl_short_term"
                                              : "lbl_short_term"
                                            : "lbl_short_term"}
                                        </label>
                                        <input
                                          id="16"
                                          type="checkbox"
                                          value={shortTerm}
                                          name="availableType"
                                          onChange={() => {
                                            if (shortTerm !== true) {
                                              setLongTerm(false);
                                              setShortTerm(true);
                                            }
                                          }}
                                          checked={shortTerm === true}
                                        />
                                      </div>
                                      { availabilityError && (
                                  <span className="invalid_span">
                                    { availabilityError}
                                  </span>
                                )}
                                     
                                    </Col>
                                    <Col
                                      lg="6"
                                      md="6"
                                      sm="6"
                                      xs="6"
                                      className="checkbox-styles1"
                                    >
                                
                                      <div className="field-group21  d-flex align-items-center">
                                        <label htmlFor="17" className="fw-semibold">
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_long_term"
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_long_term"
                                                )[0]["value"] || "lbl_long_term"
                                              : "lbl_long_term"
                                            : "lbl_long_term"}
                                        </label>
                                        <input
                                          id="17"
                                          type="checkbox"
                                          value={longTerm}
                                          name="availableType"
                                          onChange={() => {
                                            if (longTerm !== true) {
                                              setLongTerm(true);
                                              setShortTerm(false);
                                            }
                                          }}
                                          checked={longTerm === true}
                                        />
                                      </div>
                                    </Col>
                             
                                  </Row>
                              
                                  <Row className="row_style1 mt-2">
                                    {(shortTerm || longTerm) && (
                                      <Col xs="6" className=" mt-1 d-flex align-items-center pe-0">
                                        <Label className="renter-info-label  width-classxss mb-0 fw-semibold">
                                          {frontLabelsName
                                            ? frontLabelsName.filter(
                                                (e) => e.key == "lbl_from"
                                              ).length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_from"
                                                )[0]["value"] || "lbl_from"
                                              : "lbl_from"
                                            : "lbl_from"}<span className="invalid_span">*</span>
                                        </Label>
                                        <div style={{ position: "relative" }}>
                                          <FaCalendarAlt
                                            className="date-stylexx"
                                            
                                          />
                                          <DatePicker
                                            selected={availableFrom}
                                            onChange={(date) => setAvailableFrom(date)}
                                            dateFormat="dd/MM/yyyy"
                                            isClearable={availableFrom ? true : false}
                                            placeholderText="Available From"
                                            className="date_style"
                                            minDate={new Date()}
                                          />
                                          {fromDateError && (
                                            <span className="invalid_span">
                                              {fromDateError}
                                            </span>
                                          )}
                                        </div>
                                      </Col>
                                    )}
                                    {shortTerm === true && (
                                      <Col xs="6" className=" mt-1 d-flex align-items-center">
                                        <Label className="renter-info-label  width-30 mb-0 fw-semibold">
                                          {frontLabelsName
                                            ? frontLabelsName.filter((e) => e.key == "lbl_to")
                                                .length > 0
                                              ? frontLabelsName.filter(
                                                  (e) => e.key == "lbl_to"
                                                )[0]["value"] || "lbl_to"
                                              : "lbl_to"
                                            : "lbl_to"}<span className="invalid_span">*</span>
                                        </Label>
                                        <div style={{ position: "relative" }}>
                                          <FaCalendarAlt
                                           className="date-stylexx"
                                          />
              
                                          <DatePicker
                                            selected={availableTo}
                                            onChange={(date) => setAvailableTo(date)}
                                            dateFormat="dd/MM/yyyy"
                                            isClearable={availableTo ? true : false}
                                            placeholderText="Available To"
                                            className="date_style"
                                            minDate={new Date()}
                                          />
                                          {toDateError && (
                                            <span className="invalid_span">
                                              {toDateError}
                                            </span>
                                          )}
                                        </div>
                                      </Col>
                                    )}
                                  </Row>
                          
                                          </Col> */}
                                     
                                    
                                        </Row>
                                      </FormGroup>
                                    </div>
                                    <div>
                                      
                                   
                                    
                                    </div>
              
                                
                                  </div>
                 

                    <div className="buton-left-renter-info1  d-flex pt-1">
              <div className="button-left">
                            <Button
                            className="btn-size width-200-class"
                            onClick={handleBackTenantList}
                            disabled={disableSubmitButton}
                          >
                              <BsArrowLeft
                              style={{
                                fontSize: "24px",
                                fontWeight: "bold",
                                paddingRight: "5px",
                              }}
                            />
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_back")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_back"
                                  )[0]["value"] || "lbl_back"
                                : "lbl_back"
                              : "lbl_back"}
                          
                          </Button>
              </div>
                      <div className="renter-list-buttons">
                 {isSubscribing === "true" &&  <div className="button-left">
                      
                            <Button className="btn-size" onClick={handleSkip}>
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_skip")
                                    .length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_skip"
                                    )[0]["value"] || "lbl_skip"
                                  : "lbl_skip"
                                : "lbl_skip"}
                            </Button>
                  
                        </div>} 
                        <div className="button-left">
                          <Button
                            className="btn-size"
                            onClick={handleAddTenantList}
                            disabled={disableSubmitButton}
                          >
                            {disableSubmitButton ? (
                        <CircularProgress
                          size={24}
                          sx={{
                            ":hover": { color: "#000" },

                            color: "#000",
                           
                          }}
                        />
                      ) :frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_next")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_next"
                                  )[0]["value"] || "lbl_next"
                                : "lbl_next"
                              : "lbl_next"}
                            <BsArrowRight
                              style={{
                                fontSize: "24px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
              <div className="col-lg-3 col-md-12">
                <div className="black-main mb-3">
                  <div className="list-black-main">
                    <ul>
                      <li>
                        <div className="custom-set-arr">
                          <span className="gray-cricle">1</span>
                          <p>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_term_condition"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_term_condition"
                                  )[0]["value"] || "lbl_term_condition"
                                : "lbl_term_condition"
                              : "lbl_term_condition"}
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="custom-set-arr">
                          <span className="gray-cricle">2</span>
                          <p>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_basic_info"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_basic_info"
                                  )[0]["value"] || "lbl_basic_info"
                                : "lbl_basic_info"
                              : "lbl_basic_info"}
                          </p>
                        </div>
                      </li>
                   
                      <li>
                        <div className="custom-set-arr">
                          <span className="yellow-cricle">     {  <BsCheck2 />}</span>
                          <p>
                          {
                          frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_tenant_list"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_tenant_list"
                              )[0]["value"] || "lbl_tenant_list"
                            : "lbl_tenant_list"
                          : "lbl_tenant_list"}
                          </p>
                        </div>
                      </li>
                      <li>
                    <div className="custom-set-arr">
                      <span
                        className={
                          "gray-cricle"
                        }
                      >
                    4
                      </span>
                      <p>
                        { frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_tenant_profile"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_tenant_profile"
                              )[0]["value"] || "lbl_tenant_profile"
                            : "lbl_tenant_profile"
                          : "lbl_tenant_profile"}
                      </p>
                    </div>
                  </li>
                    {isSubscribing === "true" &&  <li>
                          <div className="custom-set-arr">
                                                <span className="gray-cricle">5</span>
                                                <p>
                                                {frontLabelsName
                                                    ? frontLabelsName.filter(
                                                        (e) => e.key == "lbl_payment"
                                                      ).length > 0
                                                      ? frontLabelsName.filter(
                                                          (e) => e.key == "lbl_payment"
                                                        )[0]["value"] || "lbl_payment"
                                                      : "lbl_payment"
                                                    : "lbl_payment"}
                                                </p>
                                              </div>
                      </li>}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
         
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  subscriptions: state.subscription,
  label: state.language,
});

export default connect(mapStateToProps, {
  addTenantList,
  getTenantList,
 getContentDetails,
  logout,


})(Renters_list);
